import React, { useState } from "react";

export default function NewsCharts() {
  const [activeTabLeft, setActiveTabLeft] = useState(true);
  const [hoveredPoint, setHoveredPoint] = useState(null);

  // Line chart data (16/09 - 22/09)
  const lineChartPoints = [
    { date: "16/09", val: 42, label: "42 phiếu" },
    { date: "17/09", val: 56, label: "56 phiếu" },
    { date: "18/09", val: 22, label: "22 phiếu" },
    { date: "19/09", val: 78, label: "78 phiếu" },
    { date: "20/09", val: 6, label: "6 phiếu" },
    { date: "21/09", val: 4, label: "4 phiếu" },
    { date: "22/09", val: 4, label: "4 phiếu" },
  ];

  // SVG dimensions for Line Chart
  const svgWidth = 500;
  const svgHeight = 220;
  const paddingX = 45;
  const paddingY = 25;

  const maxVal = 160;
  const minVal = 0;

  const getX = (index) => {
    return paddingX + (index * (svgWidth - paddingX * 2)) / (lineChartPoints.length - 1);
  };

  const getY = (val) => {
    return (
      svgHeight -
      paddingY -
      ((val - minVal) * (svgHeight - paddingY * 2)) / (maxVal - minVal)
    );
  };

  // Generate SVG path line
  const pathD = lineChartPoints.reduce((acc, pt, i) => {
    const x = getX(i);
    const y = getY(pt.val);
    return i === 0 ? `M ${x} ${y}` : `${acc} L ${x} ${y}`;
  }, "");

  // Area path for smooth gradient below line
  const areaD = `${pathD} L ${getX(lineChartPoints.length - 1)} ${svgHeight - paddingY} L ${getX(0)} ${svgHeight - paddingY} Z`;

  // Donut chart items
  const donutData = [
    { label: "Lọ mặt bằng (thuê ngoài)", amount: "240.000.000 đ", val: 240, color: "#10b981", percent: "50.9%" },
    { label: "Lọ hoạt động", amount: "175.369.315 đ", val: 175.37, color: "#2563eb", percent: "37.2%" },
    { label: "Lọ Hàng Hóa", amount: "55.821.233 đ", val: 55.82, color: "#f59e0b", percent: "11.9%" },
  ];

  const totalAmount = "471,2 Tr";

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Left Chart Card: Chứng từ 7 ngày qua */}
      <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-200/80 flex flex-col justify-between">
        <div>
          <div className="flex items-start justify-between">
            <div>
              <h2 className="text-base font-bold text-gray-800 flex items-center gap-2">
                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
                </svg>
                Chứng từ 7 ngày qua
              </h2>
              <p className="text-xs text-gray-500 mt-1">
                Tổng ĐNTT, ĐXNV, Trích trước chi phí và ĐNTƯ theo ngày tạo • 16/09 - 22/09
              </p>
            </div>

            <button className="text-gray-400 hover:text-gray-600 p-1.5 hover:bg-gray-100 rounded-lg">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>

          {/* SVG Line Chart */}
          <div className="mt-4 relative w-full overflow-x-auto">
            <svg viewBox={`0 0 ${svgWidth} ${svgHeight}`} className="w-full h-auto min-w-[360px]">
              <defs>
                <linearGradient id="lineGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.25" />
                  <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.0" />
                </linearGradient>
              </defs>

              {/* Y Grid Lines & Labels */}
              {[0, 40, 80, 120, 160].map((gridVal) => {
                const y = getY(gridVal);
                return (
                  <g key={gridVal}>
                    <line
                      x1={paddingX}
                      y1={y}
                      x2={svgWidth - paddingX}
                      y2={y}
                      stroke="#f3f4f6"
                      strokeWidth="1"
                      strokeDasharray="4 4"
                    />
                    <text
                      x={paddingX - 8}
                      y={y + 4}
                      fill="#9ca3af"
                      fontSize="10"
                      textAnchor="end"
                    >
                      {gridVal}
                    </text>
                  </g>
                );
              })}

              {/* Area gradient */}
              <path d={areaD} fill="url(#lineGrad)" />

              {/* Line path */}
              <path d={pathD} fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />

              {/* Data points */}
              {lineChartPoints.map((pt, i) => {
                const cx = getX(i);
                const cy = getY(pt.val);
                const isHovered = hoveredPoint === i;
                return (
                  <g key={i} className="cursor-pointer" onMouseEnter={() => setHoveredPoint(i)} onMouseLeave={() => setHoveredPoint(null)}>
                    <circle cx={cx} cy={cy} r={isHovered ? "6" : "4"} fill="#ffffff" stroke="#2563eb" strokeWidth="2.5" className="transition-all duration-150" />
                    {isHovered && (
                      <g>
                        <rect x={cx - 30} y={cy - 28} width="60" height="20" rx="4" fill="#1e293b" opacity="0.9" />
                        <text x={cx} y={cy - 15} fill="#ffffff" fontSize="10" textAnchor="middle" fontWeight="bold">
                          {pt.label}
                        </text>
                      </g>
                    )}
                  </g>
                );
              })}

              {/* X Axis Labels */}
              {lineChartPoints.map((pt, i) => (
                <text
                  key={i}
                  x={getX(i)}
                  y={svgHeight - 4}
                  fill="#6b7280"
                  fontSize="11"
                  textAnchor="middle"
                >
                  {pt.date}
                </text>
              ))}
            </svg>
          </div>
        </div>

        {/* Bottom filter options / badges */}
        <div className="mt-4 flex flex-wrap gap-2 text-xs">
          <label className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 font-medium cursor-pointer border border-blue-200">
            <input type="checkbox" defaultChecked className="rounded text-blue-600 focus:ring-blue-500 w-3.5 h-3.5" />
            Phiếu đề nghị thanh toán
          </label>
          <label className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-sky-50 text-sky-700 font-medium cursor-pointer border border-sky-200">
            <input type="checkbox" defaultChecked className="rounded text-sky-600 focus:ring-sky-500 w-3.5 h-3.5" />
            Phiếu đề xuất nghiệp vụ
          </label>
          <label className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-cyan-50 text-cyan-700 font-medium cursor-pointer border border-cyan-200">
            <input type="checkbox" defaultChecked className="rounded text-cyan-600 focus:ring-cyan-500 w-3.5 h-3.5" />
            Phiếu trích trước chi phí
          </label>
          <label className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 font-medium cursor-pointer border border-indigo-200">
            <input type="checkbox" defaultChecked className="rounded text-indigo-600 focus:ring-indigo-500 w-3.5 h-3.5" />
            Phiếu đề nghị tạm ứng
          </label>
        </div>
      </div>

      {/* Right Chart Card: Chi phí theo lọ 7 ngày */}
      <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-200/80 flex flex-col justify-between">
        <div>
          <div className="flex items-start justify-between">
            <div>
              <h2 className="text-base font-bold text-gray-800 flex items-center gap-2">
                <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                </svg>
                Chi phí theo lọ 7 ngày
              </h2>
              <p className="text-xs text-gray-500 mt-1">
                Lịch chi chờ duyệt, theo ngày chi dự kiến • 22/09 - 28/09
              </p>
            </div>

            <button className="text-gray-400 hover:text-gray-600 p-1.5 hover:bg-gray-100 rounded-lg">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>

          <div className="mt-4 flex flex-col sm:flex-row items-center justify-around gap-6">
            {/* SVG Donut Chart */}
            <div className="relative w-48 h-48 shrink-0 flex items-center justify-center">
              <svg viewBox="0 0 100 100" className="w-full h-full transform -rotate-90">
                {/* Segment 1: Green (50.9%) */}
                <circle
                  cx="50"
                  cy="50"
                  r="38"
                  fill="transparent"
                  stroke="#10b981"
                  strokeWidth="16"
                  strokeDasharray="121.5 238.7"
                  strokeDashoffset="0"
                />
                {/* Segment 2: Blue (37.2%) */}
                <circle
                  cx="50"
                  cy="50"
                  r="38"
                  fill="transparent"
                  stroke="#2563eb"
                  strokeWidth="16"
                  strokeDasharray="88.8 238.7"
                  strokeDashoffset="-123"
                />
                {/* Segment 3: Amber (11.9%) */}
                <circle
                  cx="50"
                  cy="50"
                  r="38"
                  fill="transparent"
                  stroke="#f59e0b"
                  strokeWidth="16"
                  strokeDasharray="28.4 238.7"
                  strokeDashoffset="-213"
                />
              </svg>

              {/* Center total badge */}
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none text-center">
                <span className="text-xl font-extrabold text-gray-900 tracking-tight">{totalAmount}</span>
                <span className="text-[11px] font-semibold text-gray-400">tổng chờ chi</span>
              </div>
            </div>

            {/* Legend list */}
            <div className="flex flex-col gap-3 w-full sm:w-auto">
              {donutData.map((item, idx) => (
                <div key={idx} className="flex items-center justify-between gap-4 text-xs font-medium">
                  <div className="flex items-center gap-2">
                    <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: item.color }} />
                    <span className="text-gray-700">{item.label}</span>
                  </div>
                  <span className="font-bold text-gray-900 whitespace-nowrap">{item.amount}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
